import React, { useEffect, useState } from "react";
import Common_Report_Offcanvas from "../../../common_report_offcanvas/Common_Report_Offcanvas";
import E_P_P_S_F from "./e_p_p_s_f/E_P_P_S_F";
import E_P_P_S_T from "./e_p_p_s_t/E_P_P_S_T";
import {
  GetCustomerReport,
  GetExternallyProductReport,
} from "../../../../../../features/admin/report_generator/Slice";
import { useDispatch, useSelector } from "react-redux";
import { GetAll } from "../../../../../../../src/features/admin/quality_management/resource_requirement/externaldetails/Slice";
import { FixIDS } from "../../../../../../utils/fixIDS";

const E_P_P_S = () => {
  const [show, setShow] = useState(false);
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const externaldetails = useSelector((state) => state.externally_provided);
  const [searchParams, setSearchParams] = useState({
    contact_no: "",
    email: "",
    vender_name: "",
    end_date: "",
    start_date: "",
  });

  const permissions = useSelector((state) => state.auth.permissions);
    const haveReportPermission = permissions?.includes(FixIDS.externally_provided_report.Report);

  const fetchCustomers = async (page = 1) => {
    await dispatch(
      GetAll({
        email: searchParams?.email,
        contact_no: searchParams?.contact_no,
        vender_name: searchParams?.vender_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page,
        per_page: externaldetails.per_page,
      }),
    );
  };
console.log(searchParams,"searchParams searchParams");

  useEffect(() => {
    fetchCustomers(currentPage);
  }, [currentPage, searchParams]);

  const [showLottie, setShowLottie] = useState(true);
  const [reportPath, setReportPath] = useState("");
  const reportgenerate = async () => {
    setShow(true);
    setShowLottie(true);
    const response = await dispatch(
      GetExternallyProductReport({
        email: searchParams?.email,
        contact_no: searchParams?.contact_no,
        vender_name: searchParams?.vender_name,
        end_date: searchParams?.end_date,
        start_date: searchParams?.start_date,
        page: 1,
        per_page: externaldetails.per_page,
      }),
    );

    if (response?.meta?.requestStatus === "fulfilled") {
      const path = response?.payload?.path;
      setReportPath(path);
      setShowLottie(false);
    } else {
      setShowLottie(false); // also stop loader on error
    }
  };
  return (
    <section className="Sample_Report">
      <div className="Sample_Report_Filter_div">
        <E_P_P_S_F
          setShow={setShow}
          reportgenerate={reportgenerate}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      </div>

      <div className="report_table_div">
        { haveReportPermission && <E_P_P_S_T
          data={externaldetails}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
        />}
      </div>

      <Common_Report_Offcanvas
        reportPath={reportPath}
        reportgenerate={reportgenerate}
        setShowLottie={setShowLottie}
        showLottie={showLottie}
        title={"Externally Provided Product Services Report"}
        show={show}
        setShow={setShow}
        handleClose={() => {
          setShow(false);
        }}
      />
    </section>
  );
};

export default E_P_P_S;
